module.exports = __webpack_public_path__ + "static/media/devices white.89fecd94.svg";